// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../Assets/Images/banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0%, 30%, 50%, 70%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
}
.pro-sidebar {
  color: #adadad;
  height: 100%;
  width: 270px;
  min-width: 270px;
  text-align: left;
  transition: width, left, right, 0.3s;
  position: relative;
  z-index: 1009;
}
.pro-sidebar > .pro-sidebar-inner {
  background: #1d1d1d;
  height: 100%;
  position: relative;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 100;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 1;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pro-sidebar .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: none;
}
.pro-sidebar.collapsed {
  width: 80px;
  min-width: 80px;
}
.pro-sidebar.rtl {
  text-align: right;
  direction: rtl;
}
@media (max-width: 480px) {
  .pro-sidebar.xs {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xs.collapsed {
    left: -80px;
  }
  .pro-sidebar.xs.toggled {
    left: 0;
  }
  .pro-sidebar.xs.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xs.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xs.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xs.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 576px) {
  .pro-sidebar.sm {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.sm.collapsed {
    left: -80px;
  }
  .pro-sidebar.sm.toggled {
    left: 0;
  }
  .pro-sidebar.sm.toggled .overlay {
    display: block;
  }
  .pro-sidebar.sm.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.sm.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.sm.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 768px) {
  .pro-sidebar.md {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.md.collapsed {
    left: -80px;
  }
  .pro-sidebar.md.toggled {
    left: 0;
  }
  .pro-sidebar.md.toggled .overlay {
    display: block;
  }
  .pro-sidebar.md.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.md.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.md.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 992px) {
  .pro-sidebar.lg {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.lg.collapsed {
    left: -80px;
  }
  .pro-sidebar.lg.toggled {
    left: 0;
  }
  .pro-sidebar.lg.toggled .overlay {
    display: block;
  }
  .pro-sidebar.lg.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.lg.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.lg.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1200px) {
  .pro-sidebar.xl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xl.toggled {
    left: 0;
  }
  .pro-sidebar.xl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xl.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1600px) {
  .pro-sidebar.xxl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xxl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xxl.toggled {
    left: 0;
  }
  .pro-sidebar.xxl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xxl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xxl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xxl.rtl.toggled {
    left: auto;
    right: 0;
  }
}

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: "";
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid #2b2b2b;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #adadad, 0px -1px 0px #adadad, 0px 1px 0px #adadad, -1px 0px 0px #adadad;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  position: relative;
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pro-sidebar .pro-menu a {
  text-decoration: none;
  color: #adadad;
}
.pro-sidebar .pro-menu a:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
}
.pro-sidebar .pro-menu a:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
  display: flex;
  margin-right: 5px;
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 35px 8px 20px;
  cursor: pointer;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 10px;
  font-size: 14px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  background: #adadad;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #adadad;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.3s;
  transform: rotate(-45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  background: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 24px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  background: none;
  width: auto;
  min-width: auto;
  height: auto;
  line-height: auto;
}
.pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 0;
}
.pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 4px;
}
.pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 50%;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
  background-color: #2b2b2b;
  z-index: 111;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-left: 10px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background-color: #2b2b2b;
  padding-left: 20px;
  border-radius: 4px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility, transform 0.3s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 0;
  margin-left: 10px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(135deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 15px 8px 30px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  margin-right: 0;
  margin-left: 15px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-right: 10px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  padding-left: 0;
  padding-right: 20px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px;
}

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.popper-element[data-popper-placement^=left] > .popper-arrow {
  right: 0;
  border-right: 7px solid #2b2b2b;
}

.popper-element[data-popper-placement^=right] > .popper-arrow {
  left: 0;
  border-left: 7px solid #2b2b2b;
}

.react-slidedown {
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.react-slidedown.transitioning {
  overflow-y: hidden;
}

.react-slidedown.closed {
  display: none;
}

.font_size_password {
  font-size: 80%;
  color: #808080;
  font-weight: 400;
}

.font_size_error {
  font-size: 10px;
  color: #808080;
  font-weight: 400;
}

.paddings {
  padding-left: 35% !important;
  padding-right: 35% !important;
}

.padding_in_create_password {
  padding-left: 32% !important;
  padding-right: 32% !important;
}

.font_size_heading {
  font-size: 12px;
  color: #000;
  font-weight: 500;
}

.img_profile_shape11 {
  height: 100px;
  width: 100px;
  object-fit: fill;
  border-radius: 50px;
}

.button_login {
  width: auto !important;
  font-size: 90% !important;
  border-radius: 1px !important;
  padding: 2px 10px !important;
  background-color: #007bb6 !important;
}

.button_login:hover {
  width: auto !important;
  font-size: 90% !important;
  border-radius: 1px !important;
  padding: 2px 10px !important;
  background-color: #007bb6 !important;
}

.login_height {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.background_image_login {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.heading_login {
  font-size: 32px;
  font-family: "Poppins";
  padding-top: 12%;
  font-weight: 400;
  color: #fff;
}

.heading2_login {
  font-size: 50px;
  font-family: "Poppins";
  font-weight: 500;
  line-height: 115%;
  color: #fff;
  text-transform: uppercase;
}

.heading3_login {
  font-size: 28px;
  font-family: "Poppins";
  font-weight: 400;
  line-height: 115%;
  color: #fff;
}

.heading4_login {
  padding-top: 5%;
  color: #131313;
  font-weight: 1000 !important;
  font-size: 26px;
}

.heading5_login {
  font-weight: 400 !important;
  font-size: 20px;
  color: Gray;
}

.label_login {
  font-size: 12px;
  color: Gray;
  font-weight: 400 !important;
}

.join_login {
  font-size: 12px;
  color: Gray;
  font-weight: 400 !important;
}

.join2_login {
  font-size: 12px;
  color: #0575E6;
  font-weight: 400 !important;
}

.button_linkedin {
  font-size: 22px;
}

.mob_logo {
  display: none;
}

.link_decoration {
  text-decoration: none;
}

.text_color_line {
  color: #131313;
}

.button_style_login {
  background-color: #25224a !important;
  border-top-left-radius: 1px !important;
  font-size: 80%;
}

.button_style_login:hover {
  background-color: #25224a !important;
  border-top-left-radius: 1px !important;
  font-size: 80%;
}

.right_arrow_login {
  color: #74ac72;
}

.img_width_login {
  width: 100%;
}

.img_bulb_width {
  width: 3.5%;
}

.warning_text {
  color: red;
  font-size: 80%;
  padding-top: 2%;
}

.center_copyright {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.show_privacy_policy {
  display: flex;
}

@media (max-width: 980px) {
  .center_copyright {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .login_height {
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .paddings {
    padding-left: 25% !important;
    padding-right: 25% !important;
  }
  .background_image_login {
    display: none;
  }
  .heading4_login {
    padding-top: 5%;
    color: #0575E6;
    font-weight: 700 !important;
    font-size: 26px;
  }
  .mob_logo {
    padding-top: 30% !important;
    display: block;
  }
  .show_privacy_policy {
    display: flex;
  }
  .mobile_padding_bottom {
    padding-bottom: 15% !important;
  }
  .heading4_login {
    padding-top: 40%;
    color: #131313;
    font-weight: 1000 !important;
    font-size: 26px;
  }
}
@media (max-width: 480px) {
  .paddings {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 25%;
  }
  .padding_in_create_password {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 10%;
  }
  .show_privacy_policy {
    display: none;
  }
  .center_copyright {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_animation.scss","webpack://./src/Pages/Auth/Login/Login.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_sidebar.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/variables.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_menu.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_popperArrow.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_reactSlidedown.scss","webpack://./src/Assets/Scss/veriables.scss"],"names":[],"mappings":"AAAA;EACE;IAKE,uBAAA;ECDF;EDIA;IACE,wBAAA;ECFF;EDKA;IACE,yBAAA;ECHF;EDMA;IACE,uBAAA;ECJF;EDOA;IACE,wBAAA;ECLF;AACF;ACQA;EACE,cC1Bc;ED2Bd,YAAA;EACA,YC3Bc;ED4Bd,gBC5Bc;ED6Bd,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;ADNF;ACOE;EACE,mBCpCe;EDqCf,YAAA;EACA,kBAAA;EACA,YAAA;ADLJ;ACOI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;ADLN;ACQI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ADNN;ACQM;EACE,iDAAA;ADNR;ACQM;EACE,YAAA;ADNR;ACQM;EACE,8CAAA;ADNR;ACQM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;ADNR;ACWE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;ADTJ;ACYE;EACE,WCxFsB;EDyFtB,eCzFsB;AF+E1B;ACaE;EACE,iBAAA;EACA,cAAA;ADXJ;ACeI;EADF;IAnGA,eAAA;IACA,YAAA;EDyFA;ECxFA;IACE,WAAA;ED0FF;ECxFA;IACE,OAAA;ED0FF;ECzFE;IACE,cAAA;ED2FJ;ECxFA;IACE,UAAA;IACA,aAAA;ED0FF;ECzFE;IACE,UAAA;IACA,YAAA;ED2FJ;ECzFE;IACE,UAAA;IACA,QAAA;ED2FJ;AACF;ACPI;EADF;IAxGA,eAAA;IACA,YAAA;EDoHA;ECnHA;IACE,WAAA;EDqHF;ECnHA;IACE,OAAA;EDqHF;ECpHE;IACE,cAAA;EDsHJ;ECnHA;IACE,UAAA;IACA,aAAA;EDqHF;ECpHE;IACE,UAAA;IACA,YAAA;EDsHJ;ECpHE;IACE,UAAA;IACA,QAAA;EDsHJ;AACF;AC7BI;EADF;IA7GA,eAAA;IACA,YAAA;ED+IA;EC9IA;IACE,WAAA;EDgJF;EC9IA;IACE,OAAA;EDgJF;EC/IE;IACE,cAAA;EDiJJ;EC9IA;IACE,UAAA;IACA,aAAA;EDgJF;EC/IE;IACE,UAAA;IACA,YAAA;EDiJJ;EC/IE;IACE,UAAA;IACA,QAAA;EDiJJ;AACF;ACnDI;EADF;IAlHA,eAAA;IACA,YAAA;ED0KA;ECzKA;IACE,WAAA;ED2KF;ECzKA;IACE,OAAA;ED2KF;EC1KE;IACE,cAAA;ED4KJ;ECzKA;IACE,UAAA;IACA,aAAA;ED2KF;EC1KE;IACE,UAAA;IACA,YAAA;ED4KJ;EC1KE;IACE,UAAA;IACA,QAAA;ED4KJ;AACF;ACzEI;EADF;IAvHA,eAAA;IACA,YAAA;EDqMA;ECpMA;IACE,WAAA;EDsMF;ECpMA;IACE,OAAA;EDsMF;ECrME;IACE,cAAA;EDuMJ;ECpMA;IACE,UAAA;IACA,aAAA;EDsMF;ECrME;IACE,UAAA;IACA,YAAA;EDuMJ;ECrME;IACE,UAAA;IACA,QAAA;EDuMJ;AACF;AC/FI;EADF;IA5HA,eAAA;IACA,YAAA;EDgOA;EC/NA;IACE,WAAA;EDiOF;EC/NA;IACE,OAAA;EDiOF;EChOE;IACE,cAAA;EDkOJ;EC/NA;IACE,UAAA;IACA,aAAA;EDiOF;EChOE;IACE,UAAA;IACA,YAAA;EDkOJ;EChOE;IACE,UAAA;IACA,QAAA;EDkOJ;AACF;;AGvPE;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gGAAA;AH0PJ;;AGrPA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AHwPF;;AGpPE;EACE,iBAAA;EACA,oBAAA;AHuPJ;AGnPQ;EACE,kBAAA;EACA,yBD1BS;AF+QnB;AGnPU;EACE,iBAAA;EACA,oBAAA;AHqPZ;AGhPI;EACE,qBAAA;EACA,cDzCU;AF2RhB;AGjPM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AHmPR;AGjPM;EACE,cDjDU;AFoSlB;AGhPI;EACE,eAAA;AHkPN;AGjPM;EACE,cDvDU;AF0SlB;AGhPM;EACE,UAAA;EACA,wBAAA;AHkPR;AGhPM;EACE,aAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;AHkPR;AG/OM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AHiPR;AG/OQ;EACE,aAAA;EACA,cD9EQ;AF+TlB;AG/OQ;EACE,kBAAA;EACA,eAAA;EACA,WD/EE;ECgFF,eDhFE;ECiFF,YDjFE;ECkFF,iBDlFE;ECmFF,kBAAA;EACA,qBAAA;AHiPV;AG/OU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AHiPZ;AG7OQ;EACE,YAAA;EACA,cAAA;AH+OV;AG1OQ;EACE,cD1GQ;AFsVlB;AG1OY;EACE,6CAAA;AH4Od;AGpOU;EACE,mBDzHI;AF+VhB;AGnOU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AHqOZ;AGnOY;EACE,qBAAA;EACA,mBAAA;EACA,qBDrIE;ECsIF,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AHqOd;AG9NY;EACE,kCAAA;AHgOd;AG7Nc;EACE,wBAAA;AH+NhB;AGzNQ;EACE,kBDrJO;AFgXjB;AGzNU;EACE,0BAAA;AH2NZ;AGzNY;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AH2Nd;AGnNM;EACE,aAAA;AHqNR;AGzMU;EACE,yBDvLI;AFkYhB;AGlMU;EACE,gBAAA;AHoMZ;AG5LU;EACE,kBAAA;AH8LZ;AGtLU;EACE,kBAAA;AHwLZ;AG5KQ;EAWE,kBAAA;AHoKV;AG7KY;;EAEE,UAAA;AH+Kd;AG5KU;EACE,yBDxOiB;ECyOjB,YAAA;AH8KZ;AG3KU;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AH6KZ;AG3KU;EACE,kBAAA;AH6KZ;AG3KY;EACE,oBAAA;AH6Kd;AG3Kc;EACE,aAAA;AH6KhB;AG1KY;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AH4Kd;AG3Kc;EACE,kBAAA;AH6KhB;AG3Kc;EACE,iBAAA;EACA,gBAAA;EACA,yBD/Qa;ECgRb,kBAAA;EACA,kBAAA;AH6KhB;AGzKc;EACE,sCAAA;EACA,mBAAA;AH2KhB;AGxKgB;EACE,6CAAA;AH0KlB;AGpKc;;EAEE,yBAAA;AHsKhB;AGzJQ;EACE,eAAA;EACA,gBAAA;AH2JV;AGzJQ;EACE,0BAAA;AH2JV;AG1JU;EACE,eAAA;EACA,iBAAA;AH4JZ;AGtJY;EACE,WAAA;EACA,UAAA;AHwJd;AGvJc;EACE,yBAAA;AHyJhB;AGlJgB;EACE,wBAAA;AHoJlB;AG9IU;EACE,eAAA;EACA,mBD/UK;AF+djB;AG9IY;EACE,0BAAA;AHgJd;AG/Ic;EACE,eAAA;EACA,iBAAA;AHiJhB;AGnIc;EACE,eAAA;EACA,kBAAA;AHqIhB;AGpIgB;EACE,mBAAA;AHsIlB;AGpIgB;EACE,eAAA;EACA,mBAAA;AHsIlB;AGjIgB;;EAEE,yBAAA;AHmIlB;;AI9fA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;AJigBF;;AI9fA;EACE,QAAA;EACA,+BAAA;AJigBF;;AI9fA;EACE,OAAA;EACA,8BAAA;AJigBF;;AKjhBA;EACE,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;ALohBF;;AKjhBA;EACE,kBAAA;ALohBF;;AKjhBA;EACE,aAAA;ALohBF;;AA7hBA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;AAgiBF;;AA9hBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAiiBF;;AA9hBA;EACE,4BAAA;EACA,6BAAA;AAiiBF;;AA7hBA;EACE,4BAAA;EACA,6BAAA;AAgiBF;;AA9hBA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAiiBF;;AA/hBA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAkiBF;;AA/hBA;EACE,sBAAA;EACA,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,oCAAA;AAkiBF;;AA/hBA;EACE,sBAAA;EACA,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,oCAAA;AAkiBF;;AA/hBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AAkiBF;;AA9hBA;EACE,yDAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAiiBF;;AA9hBA;EACE,eMpBQ;ENqBR,sBMlEY;ENmEZ,gBAAA;EACA,gBMhBgB;ENiBhB,WMjEM;ANkmBR;;AA9hBA;EACE,eM1BQ;EN2BR,sBM1EY;EN2EZ,gBMtBgB;ENuBhB,iBAAA;EACA,WMzEM;EN0EN,yBAAA;AAiiBF;;AA9hBA;EACE,eMtCQ;ENuCR,sBMnFY;ENoFZ,gBMhCgB;ENiChB,iBAAA;EACA,WMlFM;ANmnBR;;AA9hBA;EACE,eAAA;EACA,cMhFM;ENiFN,4BAAA;EACA,eMlDQ;ANmlBV;;AA9hBA;EACE,2BAAA;EACA,eM1DQ;EN2DR,WMpFK;ANqnBP;;AA9hBA;EACE,eMrEQ;ENsER,WMzFK;EN0FL,2BAAA;AAiiBF;;AA9hBA;EACE,eM3EQ;EN4ER,WM/FK;ENgGL,2BAAA;AAiiBF;;AA9hBA;EACE,eMjFQ;ENkFR,cMtGK;ENuGL,2BAAA;AAiiBF;;AA9hBA;EACE,eMhFQ;ANinBV;;AA9hBA;EACE,aAAA;AAiiBF;;AA9hBA;EACE,qBAAA;AAiiBF;;AA9hBA;EACE,cM1HM;AN2pBR;;AA7hBA;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAgiBF;;AA7hBA;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAgiBF;;AA7hBA;EACE,cAAA;AAgiBF;;AA7hBA;EACE,WAAA;AAgiBF;;AA7hBA;EACE,WAAA;AAgiBF;;AA7hBA;EACE,UAAA;EACA,cAAA;EACA,eAAA;AAgiBF;;AA7hBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAgiBF;;AA7hBA;EACE,aAAA;AAgiBF;;AA7hBA;EACE;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;EAgiBF;EA9hBA;IACE,YAAA;IACA,gBAAA;IACA,kBAAA;EAgiBF;EA7hBA;IACE,4BAAA;IACA,6BAAA;EA+hBF;EA3hBA;IACE,aAAA;EA6hBF;EA1hBA;IACE,eAAA;IACA,cM5LG;IN6LH,2BAAA;IACA,eMjKM;EN6rBR;EAzhBA;IACE,2BAAA;IACA,cAAA;EA2hBF;EAxhBA;IACE,aAAA;EA0hBF;EAvhBA;IACE,8BAAA;EAyhBF;EAthBA;IACE,gBAAA;IACA,cMnNI;INoNJ,4BAAA;IACA,eMrLM;EN6sBR;AACF;AArhBA;EACE;IACE,0BAAA;IACA,2BAAA;IACA,gBAAA;EAuhBF;EAphBA;IACE,0BAAA;IACA,2BAAA;IACA,gBAAA;EAshBF;EAnhBA;IACE,aAAA;EAqhBF;EAlhBA;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;EAohBF;AACF","sourcesContent":["@keyframes swing {\n  0%,\n  30%,\n  50%,\n  70%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(10deg);\n  }\n\n  40% {\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  80% {\n    transform: rotate(-5deg);\n  }\n}\n","@import \"../../../Assets/Scss/veriables.scss\";\n@import \"~react-pro-sidebar/dist/scss/styles.scss\";\n\n.font_size_password {\n  font-size: 80%;\n  color: #808080;\n  font-weight: 400;\n}\n.font_size_error {\n  font-size: 10px;\n  color: #808080;\n  font-weight: 400;\n}\n\n.paddings {\n  padding-left: 35% !important;\n  padding-right: 35% !important;\n  // padding-top: 10%;\n}\n\n.padding_in_create_password {\n  padding-left: 32% !important;\n  padding-right: 32% !important;\n}\n.font_size_heading {\n  font-size: 12px;\n  color: #000;\n  font-weight: 500;\n}\n.img_profile_shape11 {\n  height: 100px;\n  width: 100px;\n  object-fit: fill;\n  border-radius: 50px;\n}\n\n.button_login {\n  width: auto !important;\n  font-size: 90% !important;\n  border-radius: 1px !important;\n  padding: 2px 10px !important;\n  background-color: #007bb6 !important;\n}\n\n.button_login:hover {\n  width: auto !important;\n  font-size: 90% !important;\n  border-radius: 1px !important;\n  padding: 2px 10px !important;\n  background-color: #007bb6 !important;\n}\n\n.login_height {\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  // padding-top: 5%;\n}\n\n.background_image_login {\n  background-image: url(\"../../../Assets/Images/banner.png\");\n  height: 100vh;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.heading_login {\n  font-size: $font-32;\n  font-family: $font-family;\n  padding-top: 12%;\n  font-weight: $font-weight-400;\n  color: $white;\n}\n\n.heading2_login {\n  font-size: $font-50;\n  font-family: $font-family;\n  font-weight: $font-weight-500;\n  line-height: 115%;\n  color: $white;\n  text-transform: uppercase;\n}\n\n.heading3_login {\n  font-size: $font-28;\n  font-family: $font-family;\n  font-weight: $font-weight-400;\n  line-height: 115%;\n  color: $white;\n}\n\n.heading4_login {\n  padding-top: 5%;\n  color: $black;\n  font-weight: 1000 !important;\n  font-size: $font-26;\n}\n\n.heading5_login {\n  font-weight: $font-weight-400 !important;\n  font-size: $font-20;\n  color: $gray;\n}\n\n.label_login {\n  font-size: $font-12;\n  color: $gray;\n  font-weight: $font-weight-400 !important;\n}\n\n.join_login {\n  font-size: $font-12;\n  color: $gray;\n  font-weight: $font-weight-400 !important;\n}\n\n.join2_login {\n  font-size: $font-12;\n  color: $blue;\n  font-weight: $font-weight-400 !important;\n}\n\n.button_linkedin {\n  font-size: $font-22;\n}\n\n.mob_logo {\n  display: none;\n}\n\n.link_decoration {\n  text-decoration: none;\n}\n\n.text_color_line {\n  color: $black;\n  // font-size: 10px;\n}\n\n.button_style_login {\n  background-color: #25224a !important;\n  border-top-left-radius: 1px !important;\n  font-size: 80%;\n}\n\n.button_style_login:hover {\n  background-color: #25224a !important;\n  border-top-left-radius: 1px !important;\n  font-size: 80%;\n}\n\n.right_arrow_login {\n  color: #74ac72;\n}\n\n.img_width_login {\n  width: 100%;\n}\n\n.img_bulb_width {\n  width: 3.5%;\n}\n\n.warning_text {\n  color: red;\n  font-size: 80%;\n  padding-top: 2%;\n}\n\n.center_copyright {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.show_privacy_policy {\n  display: flex;\n}\n\n@media (max-width: 980px) {\n  .center_copyright {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n  .login_height {\n    height: auto;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n\n  .paddings {\n    padding-left: 25% !important;\n    padding-right: 25% !important;\n    // padding-top: 15%;\n  }\n\n  .background_image_login {\n    display: none;\n  }\n\n  .heading4_login {\n    padding-top: 5%;\n    color: $blue;\n    font-weight: $font-weight-700 !important;\n    font-size: $font-26;\n  }\n\n  .mob_logo {\n    padding-top: 30% !important;\n    display: block;\n  }\n\n  .show_privacy_policy {\n    display: flex;\n  }\n\n  .mobile_padding_bottom {\n    padding-bottom: 15% !important;\n  }\n\n  .heading4_login {\n    padding-top: 40%;\n    color: $black;\n    font-weight: 1000 !important;\n    font-size: $font-26;\n  }\n}\n\n@media (max-width: 480px) {\n  .paddings {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    padding-top: 25%;\n  }\n\n  .padding_in_create_password {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    padding-top: 10%;\n  }\n\n  .show_privacy_policy {\n    display: none;\n  }\n\n  .center_copyright {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n}\n","@mixin break-point {\n  position: fixed;\n  left: -$sidebar-width;\n  &.collapsed {\n    left: -$sidebar-collapsed-width;\n  }\n  &.toggled {\n    left: 0;\n    .overlay {\n      display: block;\n    }\n  }\n  &.rtl {\n    left: auto;\n    right: -$sidebar-width;\n    &.collapsed {\n      left: auto;\n      right: -$sidebar-collapsed-width;\n    }\n    &.toggled {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n.pro-sidebar {\n  color: $sidebar-color;\n  height: 100%;\n  width: $sidebar-width;\n  min-width: $sidebar-width;\n  text-align: left;\n  transition: width, left, right, 0.3s;\n  position: relative;\n  z-index: 1009;\n  > .pro-sidebar-inner {\n    background: $sidebar-bg-color;\n    height: 100%;\n    position: relative;\n    z-index: 101;\n\n    > img.sidebar-bg {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n      position: absolute;\n      opacity: 0.3;\n      left: 0;\n      top: 0;\n      z-index: 100;\n    }\n\n    > .pro-sidebar-layout {\n      height: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      z-index: 101;\n\n      .pro-sidebar-header {\n        border-bottom: 1px solid rgba($sidebar-color, 0.2);\n      }\n      .pro-sidebar-content {\n        flex-grow: 1;\n      }\n      .pro-sidebar-footer {\n        border-top: 1px solid rgba($sidebar-color, 0.2);\n      }\n      ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(#000, 0.3);\n    z-index: 100;\n    display: none;\n  }\n\n  &.collapsed {\n    width: $sidebar-collapsed-width;\n    min-width: $sidebar-collapsed-width;\n  }\n\n  &.rtl {\n    text-align: right;\n    direction: rtl;\n  }\n\n  &.xs {\n    @media (max-width: $breakpoint-xs) {\n      @include break-point;\n    }\n  }\n  &.sm {\n    @media (max-width: $breakpoint-sm) {\n      @include break-point;\n    }\n  }\n  &.md {\n    @media (max-width: $breakpoint-md) {\n      @include break-point;\n    }\n  }\n  &.lg {\n    @media (max-width: $breakpoint-lg) {\n      @include break-point;\n    }\n  }\n  &.xl {\n    @media (max-width: $breakpoint-xl) {\n      @include break-point;\n    }\n  }\n  &.xxl {\n    @media (max-width: $breakpoint-xxl) {\n      @include break-point;\n    }\n  }\n}\n","$sidebar-bg-color: #1d1d1d !default;\n$sidebar-color: #adadad !default;\n$sidebar-width: 270px !default;\n$sidebar-collapsed-width: 80px !default;\n$highlight-color: #d8d8d8 !default;\n$submenu-bg-color: #2b2b2b !default;\n$submenu-bg-color-collapsed: #2b2b2b !default;\n$icon-bg-color: #2b2b2b !default;\n$icon-size: 35px !default;\n$submenu-indent: 24px !default;\n\n$breakpoint-xs: 480px !default;\n$breakpoint-sm: 576px !default;\n$breakpoint-md: 768px !default;\n$breakpoint-lg: 992px !default;\n$breakpoint-xl: 1200px !default;\n$breakpoint-xxl: 1600px !default;\n","%pro-item-prefix {\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    min-width: 4px;\n    height: 4px;\n    border: 1px solid $submenu-bg-color;\n    border-radius: 50%;\n    margin-right: 15px;\n    position: relative;\n    box-shadow: 1px 0px 0px $sidebar-color, 0px -1px 0px $sidebar-color, 0px 1px 0px $sidebar-color,\n      -1px 0px 0px $sidebar-color;\n  }\n}\n\n%text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pro-sidebar {\n  .pro-menu {\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n    > ul {\n      > .pro-sub-menu {\n        > .pro-inner-list-item {\n          position: relative;\n          background-color: $submenu-bg-color;\n\n          > div > ul {\n            padding-top: 15px;\n            padding-bottom: 15px;\n          }\n        }\n      }\n    }\n    a {\n      text-decoration: none;\n      color: $sidebar-color;\n      &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: transparent;\n      }\n      &:hover {\n        color: $highlight-color;\n      }\n    }\n    .pro-menu-item {\n      font-size: 15px;\n      &.active {\n        color: $highlight-color;\n      }\n\n      .suffix-wrapper {\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n      .prefix-wrapper {\n        display: flex;\n        margin-right: 5px;\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n\n      > .pro-inner-item {\n        position: relative;\n        display: flex;\n        align-items: center;\n        padding: 8px 35px 8px 20px;\n        cursor: pointer;\n\n        &:focus {\n          outline: none;\n          color: $highlight-color;\n        }\n        > .pro-icon-wrapper {\n          margin-right: 10px;\n          font-size: 14px;\n          width: $icon-size;\n          min-width: $icon-size;\n          height: $icon-size;\n          line-height: $icon-size;\n          text-align: center;\n          display: inline-block;\n\n          .pro-icon {\n            display: flex;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        > .pro-item-content {\n          flex-grow: 1;\n          flex-shrink: 1;\n\n          @extend %text-truncate;\n        }\n\n        &:hover {\n          color: $highlight-color;\n          .pro-icon-wrapper {\n            .pro-icon {\n              animation: swing ease-in-out 0.5s 1 alternate;\n            }\n          }\n        }\n      }\n\n      &.pro-sub-menu {\n        > .pro-inner-item {\n          &:before {\n            background: $sidebar-color;\n          }\n\n          > .pro-arrow-wrapper {\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            .pro-arrow {\n              display: inline-block;\n              border-style: solid;\n              border-color: $sidebar-color;\n              border-width: 0 2px 2px 0;\n              padding: 2.5px;\n              vertical-align: middle;\n              transition: transform 0.3s;\n              transform: rotate(-45deg);\n            }\n          }\n        }\n\n        &.open {\n          > .pro-inner-item {\n            &:before {\n              background: transparent !important;\n            }\n            > .pro-arrow-wrapper {\n              .pro-arrow {\n                transform: rotate(45deg);\n              }\n            }\n          }\n        }\n\n        .pro-inner-list-item {\n          padding-left: $submenu-indent;\n\n          .pro-inner-item {\n            padding: 8px 30px 8px 15px;\n\n            > .pro-icon-wrapper {\n              background: none;\n              width: auto;\n              min-width: auto;\n              height: auto;\n              line-height: auto;\n            }\n          }\n        }\n      }\n    }\n\n    &:not(.inner-submenu-arrows) {\n      .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {\n        display: none;\n      }\n    }\n    &.submenu-bullets {\n      .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {\n        @extend %pro-item-prefix;\n      }\n    }\n\n    &.shaped {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            background-color: $icon-bg-color;\n          }\n        }\n      }\n    }\n\n    &.square {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 0;\n          }\n        }\n      }\n    }\n    &.round {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n    &.circle {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n\n  // styling when the sidebar is collapsed\n\n  &.collapsed {\n    .pro-menu {\n      > ul {\n        > .pro-menu-item {\n          > .pro-inner-item {\n            > .suffix-wrapper,\n            > .prefix-wrapper {\n              opacity: 0;\n            }\n          }\n          > .pro-inner-list-item {\n            background-color: $submenu-bg-color-collapsed;\n            z-index: 111;\n          }\n          position: relative;\n          &::before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            cursor: pointer;\n          }\n          &.pro-sub-menu {\n            position: relative;\n\n            > .pro-inner-item {\n              pointer-events: none;\n\n              > .pro-arrow-wrapper {\n                display: none;\n              }\n            }\n            > .pro-inner-list-item {\n              height: auto !important;\n              position: fixed;\n              visibility: hidden;\n              min-width: 220px;\n              max-width: 270px;\n              background-color: transparent;\n              max-height: 100%;\n              padding-left: 3px;\n              &.has-arrow {\n                padding-left: 10px;\n              }\n              > .popper-inner {\n                max-height: 100vh;\n                overflow-y: auto;\n                background-color: $submenu-bg-color-collapsed;\n                padding-left: 20px;\n                border-radius: 4px;\n              }\n            }\n            &:hover {\n              > .pro-inner-list-item {\n                transition: visibility, transform 0.3s;\n                visibility: visible;\n              }\n              .pro-icon-wrapper {\n                .pro-icon {\n                  animation: swing ease-in-out 0.5s 1 alternate;\n                }\n              }\n            }\n\n            .pro-inner-list-item {\n              .pro-sub-menu-item,\n              .pro-inner-item {\n                padding: 8px 30px 8px 5px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // styles for rtl\n  &.rtl {\n    .pro-menu {\n      .pro-menu-item {\n        .prefix-wrapper {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n        > .pro-inner-item {\n          padding: 8px 20px 8px 35px;\n          > .pro-icon-wrapper {\n            margin-right: 0;\n            margin-left: 10px;\n          }\n        }\n\n        &.pro-sub-menu {\n          > .pro-inner-item {\n            > .pro-arrow-wrapper {\n              right: auto;\n              left: 20px;\n              .pro-arrow {\n                transform: rotate(135deg);\n              }\n            }\n          }\n          &.open {\n            > .pro-inner-item {\n              > .pro-arrow-wrapper {\n                .pro-arrow {\n                  transform: rotate(45deg);\n                }\n              }\n            }\n          }\n\n          .pro-inner-list-item {\n            padding-left: 0;\n            padding-right: $submenu-indent;\n\n            .pro-inner-item {\n              padding: 8px 15px 8px 30px;\n              &:before {\n                margin-right: 0;\n                margin-left: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // styles for rtl and collapsed\n    &.collapsed {\n      .pro-menu {\n        > ul {\n          > .pro-menu-item {\n            &.pro-sub-menu {\n              > .pro-inner-list-item {\n                padding-left: 0;\n                padding-right: 3px;\n                &.has-arrow {\n                  padding-right: 10px;\n                }\n                > .popper-inner {\n                  padding-left: 0;\n                  padding-right: 20px;\n                }\n              }\n\n              .pro-inner-list-item {\n                .pro-sub-menu-item,\n                .pro-inner-item {\n                  padding: 8px 5px 8px 30px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".popper-arrow {\n  position: absolute;\n  z-index: -1;\n  width: 0;\n  height: 0;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.popper-element[data-popper-placement^='left'] > .popper-arrow {\n  right: 0;\n  border-right: 7px solid $submenu-bg-color-collapsed;\n}\n\n.popper-element[data-popper-placement^='right'] > .popper-arrow {\n  left: 0;\n  border-left: 7px solid $submenu-bg-color-collapsed;\n}\n",".react-slidedown {\n  height: 0;\n  transition-property: none;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.react-slidedown.transitioning {\n  overflow-y: hidden;\n}\n\n.react-slidedown.closed {\n  display: none;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$font-family: \"Poppins\" !default;\n$font-family-Roboto: \"Roboto\" !default;\n$font-family-Dosis: \"Dosis\" !default;\n\n$white: #fff !default;\n$light-gray: rgba(255, 255, 255, 0.5) !default;\n\n$red: #d41313 !default;\n\n$primary: #0575E6 !default;\n\n$black: #131313 !default;\n$light-black: #201f23 !default;\n$dark-black: #0e0e0e !default;\n$blue: #0575E6 !default;\n$gray: Gray !default;\n$lightgray: lightgray !default;\n$green: #42D742 !default;\n\n\n$border: 1px solid #D1D1D1 !default;\n$bold-border: 3px solid #b59b41 !default;\n\n$border-radius-10: 10px !default;\n$border-radius-20: 20px !default;\n$border-radius-24: 24px !default;\n\n$text-uppercase: uppercase !default;\n\n\n$font-8: 8px !default;\n$font-9: 9px !default;\n$font-10: 10px !default;\n$font-11: 11px !default;\n$font-12: 12px !default;\n$font-14: 14px !default;\n$font-15: 15px !default;\n$font-16: 16px !default;\n$font-17: 17px !default;\n$font-18: 18px !default;\n$font-20: 20px !default;\n$font-22: 22px !default;\n$font-24: 24px !default;\n$font-26: 26px !default;\n$font-28: 28px !default;\n$font-32: 32px !default;\n$font-36: 36px !default;\n$font-50: 50px !default;\n$font-40: 40px !default;\n$font-144: 144px !default;\n\n$font-weight-300: 300 !default;\n$font-weight-400: 400 !default;\n$font-weight-500: 500 !default;\n$font-weight-600: 600 !default;\n$font-weight-700: 700 !default;\n$font-weight-800: 800 !default;\n$font-weight-900: 900 !default;\n$font-weight-1200: 1900 !default;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
